import { render } from "./sti-dest.vue?vue&type=template&id=bfe081fc&ts=true"
import script from "./sti-dest.vue?vue&type=script&lang=ts"
export * from "./sti-dest.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__